module.exports = __webpack_public_path__ + "images/6fad39e95bb30263a4963767d8e4cc97.png";